export function rialToToman(rial: number) {
  const toman = Math.floor(rial / 10)
  return new Intl.NumberFormat("fa-IR").format(toman).replace(/,/g, ".")
}
